import React from 'react';
import './TeslaNotice.css';

const TeslaNotice = () => (
	<div className="tesla-battery__notice">
		<p>
			The actual amount of range that you may experience will vary based on your particular driving conditions. See how particular use conditions may affect your range in the simulation model.
		</p>
		<p>
			Vehicle range may vary depending on the vehicle configuration, battery age and condition, driving style and operating, environmental and climate conditions.
		</p>
	</div>
)

export default TeslaNotice;


// WEBPACK FOOTER //
// ./src/components/TeslaNotice/TeslaNotice.js